import first from 'lodash/first';
import isArray from 'lodash/isArray';
import getAdTypeControllerFromFormat from './getAdTypeControllerFromFormat';
export default function (slot) {
    const formatDefinition = isArray(slot.formatDefinition)
        ? first(slot.formatDefinition)
        : slot.formatDefinition;
    return getAdTypeControllerFromFormat(formatDefinition);
}
